module.exports = __webpack_public_path__ + "static/media/incentives-screenshot.0dd1bb63.png";